import { createFileRoute } from '@tanstack/react-router';

import { ScorecardAdminAccessRequired } from '../../auth/scorecard-admin-access';
import BulkJobsPage from '../../views/dashboard-bulk-jobs';

export function BulkJobsRoute() {
  return (
    <ScorecardAdminAccessRequired>
      <BulkJobsPage />
    </ScorecardAdminAccessRequired>
  );
}

export const Route = createFileRoute('/dashboard/bulk-jobs')({
  component: BulkJobsRoute,
});
